import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const measurementsListSlice = createSlice({
  name: "measurementsList",
  initialState: [],
  reducers: {
    setMeasurementsData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const takeoffsListSlice = createSlice({
  name: "takeoffsList",
  initialState: [],
  reducers: {
    setTakeoffsList: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const takeoffDataSlice = createSlice({
  name: "takeoffData",
  initialState: {},
  reducers: {
    setTakeoff: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const measurementsModalStatusSlice = createSlice({
  name: "measurementsModalStatus",
  initialState: { status: false },
  reducers: {
    setMeasurementsModalStatus: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const isMeasurementStartedSlice = createSlice({
  name: "isMeasurementStarted",
  initialState: { status: false },
  reducers: {
    setIsMeasurementStarted: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setMeasurementsData } = measurementsListSlice.actions;
export const { setTakeoffsList } = takeoffsListSlice.actions;
export const { setTakeoff } = takeoffDataSlice.actions;
export const { setMeasurementsModalStatus } = measurementsModalStatusSlice.actions;
export const { setIsMeasurementStarted } = isMeasurementStartedSlice.actions;

export const measurementsList = measurementsListSlice.reducer;
export const takeoffsList = takeoffsListSlice.reducer;
export const takeoffData = takeoffDataSlice.reducer;
export const measurementsModalStatus = measurementsModalStatusSlice.reducer;
export const isMeasurementStarted = isMeasurementStartedSlice.reducer;
